<template>
     <div id="Tariff" style="float: right;width:100%;height: 100%;direction:rtl">
        <div class="card" style="float: right;width:100%;height: 100%">
            <div class="card-header">
                <CRow >
                    <div style="display:flex;flex-direction:row;gap:10px;">
                        <h3 class="card-title"  > <CIcon name="cil-map" style="width: 20px;height: 20px"/>&nbsp;&nbsp;
                        اعلان ها
                    </h3>
                    <div style="flex-grow:1;">

                    </div>
                    <div>
                        <CButton  color="info" @click="DialogReport=true">گزارش‌گیری</CButton>
                    </div>
                    </div>
                </CRow>
                <CRow>
                    <CCol>
                        
                        <CSelect label="انتخاب خط"   :options="GetOtions($store.state.Fleets.RequestResponse)"  @change="changeFleet"     > </CSelect>
                    </CCol>
                    <CCol>
                        <CSelect  label="نوع اعلان"   :options="[{value:0,label:'همه'},{value:0,label:'ورود به مسیر'},{value:0,label:'خروج از مسیر'},{value:0,label:'ورود به چک پوینت'},{value:0,label:'خروج از چک پوینت'}]" @change="changeAlarm"     > </CSelect>
                    </CCol>
                    <CCol>
                        <div>
                            <label for="stTime">از:</label>
                            <date-picker  id="stTime" v-model="formDate" aria-label="از تاریخ" type="datetime" @change="GetAlarm_GetAdvance(Pagenation.PresentPage)"></date-picker>
                        </div>
                                
                    </CCol>
                    <CCol>
                        <div>
                            <label for="stopTime">تا:</label>
                            <date-picker  id="stopTime" v-model="toDate" aria-label="از تاریخ" type="datetime" @change="GetAlarm_GetAdvance(Pagenation.PresentPage)"></date-picker>
                        </div>
                    </CCol>
                    <!-- @change="indexPriority=$event.target.selectedIndex" -->

                </CRow>
            </div>
            <div class="card-body" style="float: right;width:100%;height: 100%;min-height: 450px">
                <CRow v-for="(alarm,index) in Alarms" v-bind:key="index">
                        <CAlert style="direction:rtl" show :color="alarm.Color" >
                            <span style="direction:ltr">{{ToShamsi(alarm.TS)}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span>--->&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            <span> اتوبوس با کد </span>
                            <span>&nbsp;&nbsp;&nbsp;&nbsp;{{alarm.CurrVehicleName}}&nbsp;&nbsp;</span>
                            <span>{{' '+alarm.Description}}&nbsp;&nbsp;</span>
                        </CAlert>
                        <!-- <CAlert show color="secondary">Secondary Alert</CAlert>
                        <CAlert show color="success">Success Alert</CAlert>
                        <CAlert show color="danger">Danger Alert</CAlert>
                        <CAlert show color="warning">Warning Alert</CAlert>
                        <CAlert show color="info">Info Alert</CAlert>
                        <CAlert show color="light">Light Alert</CAlert>
                        <CAlert show color="dark">Dark Alert</CAlert> -->
                </CRow>
                <CPagination
                    @update:activePage="ChangePage"
                    size="lg"
                    v-if="Pagenation.Pages>0"
                    style="float: right;width: 100%;overflow: hidden;margin-top: 20px;direction: rtl;"
                    :active-page.sync="Pagenation.PresentPage"
                    :pages="Pagenation.Pages"
                />
            </div>
        </div>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogReport">
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; گزارش‌گیری </h4>

            </template>
            <div style="display:flex;flex-direction:column;gap:10px">
                <CSelect label="انتخاب خط"   :options="GetOtions($store.state.Fleets.RequestResponse)"  @change="changeFleet"     > </CSelect>
                <CSelect  label="نوع اعلان"   :options="[{value:0,label:'همه'},{value:0,label:'ورود به مسیر'},{value:0,label:'خروج از مسیر'},{value:0,label:'ورود به چک پوینت'},{value:0,label:'خروج از چک پوینت'}]" @change="changeAlarm"     > </CSelect>
                <div>
                    <label for="stTime">از:</label>
                    <date-picker  id="stTime" v-model="formDate" aria-label="از تاریخ" type="datetime" @change="GetAlarm_GetAdvance(Pagenation.PresentPage)"></date-picker>
                </div>
                <div>
                    <label for="stopTime">تا:</label>
                    <date-picker  id="stopTime" v-model="toDate" aria-label="از تاریخ" type="datetime" @change="GetAlarm_GetAdvance(Pagenation.PresentPage)"></date-picker>
                </div>
                <div>
                    <CButton @click="GetAlarm_GetAdvanceReport(1)" color="info">دانلود</CButton>
                </div>
                <MPrint 
                        v-if="$store.state.Alarm_GetAdvanceReport.Data_1.length>0"
                        :data="$store.state.Alarm_GetAdvanceReport.Data_1"
                        label="PDF" 
                        title="آلارم ها" 
                        :From="fromDate"
                        :TO="toDate"
                        :fields="fields">
                    </MPrint>
            </div>
            <template #footer>
                <CButton @click="DialogReport = false" color="danger">بستن</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
import Vue from 'vue'
export default {
    data(){
        return {
            currentPage:1,
            indexFleet:0,
            indexAlarm:0,
            Alarms:[],
            Pagenation:{
                PresentPage:1
            },
            TimerActive:false,
            DialogReport:false,
            fromDate:'',
            toDate:'',
            fields:[{"key":"Rows","label":"ردیف"},{"key":"TS","label":"زمان"},{"key":"CurrVehicleName","label":"نام خودرو"},{"key":"FleetName","label":"نام خط"},{"key":"Name","label":"رویداد"},{"key":"Speed","label":"سرعت"},{"key":"Lat","label":"عرض جغرافیایی"},{"key":"Lon","label":"طول جغرافیایی"},{"key":"Angle","label":"زاویه خودرو"}],
        }
    },
    computed:{
        ReadAlarm_GetAdvance(){
           return this.$store.state.Alarm_GetAdvance;
        }
    },
    watch:{
        ReadAlarm_GetAdvance(data){
            this.Alarms=data.Data_1;
            this.Pagenation=data.RequestResponse[0];
        }
    },
    mounted(){
        this.InitDate()
        this.GetFleets();
        this.GetAlarmDefinitions();
        this.GetAlarm_GetAdvance(1);
        this.TimerActive=true;
        this.Refresh();
        
    },
    methods:{
        InitDate(){
            var timeNow=Vue.moment().format('YYYY-MM-DD HH:mm:ss');
            var timefrom=Vue.moment().subtract(30,'days').format('YYYY-MM-DD HH:mm:ss');
            console.log(timeNow);
            this.toDate=Vue.moment(timeNow, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
            this.formDate=Vue.moment(timefrom, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
        },
        changeFleet(data){
            this.indexFleet=data.target.selectedIndex;
            this.GetAlarm_GetAdvance(this.Pagenation.PresentPage);
        },
        changeAlarm(data){
            this.indexAlarm=data.target.selectedIndex;
            console.log(this.indexAlarm)
            this.GetAlarm_GetAdvance(this.Pagenation.PresentPage);
        },
        GetFleets(){
            this.$store.commit('FleetByUser');
        },
        GetAlarmDefinitions(){
            this.$store.commit('AlarmDefinitions_GetAll');
        },
        GetAlarm_GetAdvance(page){
            var from=Vue.moment(this.formDate, "jYYYY-jMM-jDD HH:mm").format("YYYY_MM_DD_HH_mm_ss");
            var to=Vue.moment(this.toDate, "jYYYY-jMM-jDD HH:mm").format("YYYY_MM_DD_HH_mm_ss");
            var fleetID=this.GetOtions(this.$store.state.Fleets.RequestResponse)[this.indexFleet].value;
            var alarmID=this.GetOtionsAlarm(this.$store.state.AlarmDefinitions.RequestResponse)[this.indexAlarm].value;
            this.$store.commit('Alarm_GetAdvance',{
                UserID:1,
                FleetID:fleetID,
                PageNumber:page,
                RowsOfPage:10,
                AlarmID:alarmID,
                TS1:from,
                TS2:to,

            });
            
        },
        GetAlarm_GetAdvanceReport(page){
            var from=Vue.moment(this.formDate, "jYYYY-jMM-jDD HH:mm").format("YYYY_MM_DD_HH_mm_ss");
            var to=Vue.moment(this.toDate, "jYYYY-jMM-jDD HH:mm").format("YYYY_MM_DD_HH_mm_ss");
            var fleetID=this.GetOtions(this.$store.state.Fleets.RequestResponse)[this.indexFleet].value;
            var alarmID=this.GetOtionsAlarm(this.$store.state.AlarmDefinitions.RequestResponse)[this.indexAlarm].value;
            this.$store.commit('Alarm_GetAdvanceReport',{
                UserID:1,
                FleetID:fleetID,
                PageNumber:page,
                RowsOfPage:10000000,
                AlarmID:alarmID,
                TS1:from,
                TS2:to,

            });
            
        },
        Refresh(){
         
            var delayInMilliseconds = 15000; //15 second
            var that=this;
            setTimeout(function() {
                if(that.TimerActive){
                    that.GetAlarm_GetAdvance(that.Pagenation.PresentPage);
                    that.Refresh();
                }

            }, delayInMilliseconds);
          
        },
        ChangePage(page, val2){
            this.GetAlarm_GetAdvance(page);
        },
        GetOtions(fleets){
                var options=[];
                var all={value:-1,label:'همه'};
                options.push(all);
                for(var i=0;i<fleets.length;i++){
                    var fleet=fleets[i];
                    var option={value:fleet.FleetID,label:fleet.FleetName};
                    options.push(option);
                }
                return options;
        },
        GetOtionsAlarm(items){
                var options=[];
                var all={value:0,label:'همه'};
                options.push(all);
                for(var i=0;i<items.length;i++){
                    var item=items[i];
                    if(item.Color!=null){
                        var option={value:item.AlarmID,label:item.Name};
                        options.push(option);
                    }
                    
                }
                return options;
        },
        ToShamsi(date){
            return Vue.moment(date, 'YYYY-MM-DDtHH:mm:ss').format('jYYYY/jMM/jDD HH:mm:ss');
        },
        
    },
    destroyed(){
        this.TimerActive=false;
        console.log('destroyed')
    }

}
</script>